<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file TicketList.vue is part of event_pass_client.dev.                -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - TicketList.vue can not be copied and/or distributed                       -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.-->
<!--//User: keni-->
<!--//Date: 01/03/2018-->
<!--//Time: 11:57-->

<template>
    <div data-ref="tickets-list" style="overflow-y:auto;"
         :class="ticket_classes.tickets.wrapper"
    >
        <confirm-buy-now
                :user="user"

                :payment_intent_request="payment_intent_request"
                :selected_ticket="selected_ticket"
                :pay_with_card_url="pay_with_card_url"
                :my_account_url="my_account_url"
                @confirm_buy="eventConfirmBuyNow"
                :stripe_use="stripe_use"
        />
        <div
                class="tickets-list--scroll"
                :id="ticket_wrapper_id"
        >
            <template v-for="tickets in grouped_by_entity">
                <div data-ref="tickets-of-entity"
                     :key="tickets.id"
                     :id="entityUniqueId(firstRecord(tickets).entity)"
                     class="tickets-container"
                     :class="[
                    ticket_classes.tickets.ticket,
                    {
                        'entity_highlight_target':firstRecord(tickets).entity === entity_highlight_target
                    }
                 ]"
                >

                    <!--------------------- entity details -------------------->
                    <header-overlay data-ref="entity details"
                                    @headerClick="viewEntity(firstRecord(tickets).entity)"
                                    header_class="cursor-pointer p-0 bg-secondary bg-hover-info"
                    >
                        <template slot="content">
                            <div class="d-flex justify-content-between  align-items-center">
                                <street-sign v-if="firstRecord(tickets).entity.entity_data.sign">
                                    <template slot="content">
                                        {{firstRecord(tickets).entity.entity_data.sign}}
                                    </template>
                                </street-sign>

                                <h6 class="m-0 px-1 text-truncate">
                                    {{lang('title',firstRecord(tickets).entity.entity_data.lang)}}
                                </h6>
                                <a class="cursor-pointer border-0 lh-0 ml-1">
                                    <!--<i class="icon-scale-hover material-icons md-24" aria-hidden="true">info</i>-->
                                    <!--                                    <round-button btn_type="btn-info" cls="btn-floating-responsive">-->
                                    <!--                                        <template slot="content">i</template>-->
                                    <!--                                    </round-button>-->
                                    <InfoButton class="btn-primary"></InfoButton>
                                </a>
                            </div>
                        </template>
                    </header-overlay>
                    <!------------------- the small view map ------------------>
                    <div data-map-view
                         v-if="manual_override_show_mini_map === true &&
            readEntityType(firstRecord(tickets).entity).indexOf('car','car-park') > -1
"
                         style="width: 100%; height: 250px"
                         data-small-gmap
                         class="bg-info d-block d-sm-block d-md-none"
                    >
                        <google-map
                                :center="createGoogleMarker('',firstRecord(tickets).entity).position"
                                :zoom="13"
                                ref="gmap"
                                :options="google_maps.options"
                                style="width: 100%; height: 100%"
                        >
                            <template
                                    v-if="createGoogleMarker('',firstRecord(tickets).entity).infoContent.sign !== null">
                                <gmap-marker 
                                    :position="createGoogleMarker('',firstRecord(tickets).entity).position"
                                    :clickable="true"
                                    @click="mapIconClicked(createGoogleMarker('',firstRecord(tickets).entity).infoContent.sign)"
                                    :icon="mapIcon(createGoogleMarker('',firstRecord(tickets).entity).infoContent.sign)"
                                >

                                    <div class="entity--sign entity--sign-small">
                                        <div class="d-block m-0 mb-0 px-half lh-10 fs-5 text-dark z-depth-1">
                                            {{createGoogleMarker('',firstRecord(tickets).entity).infoContent.sign}}
                                        </div>
                                    </div>
                                    
                                </gmap-marker>
                                <!-- <gmap-custom-marker
                                        :marker="createGoogleMarker('',firstRecord(tickets).entity).position"
                                >
                                    <div class="entity--sign entity--sign-small">
                                        <div class="d-block m-0 mb-0 px-half lh-10 fs-5 text-dark z-depth-1">
                                            {{createGoogleMarker('',firstRecord(tickets).entity).infoContent.sign}}
                                        </div>
                                    </div>
                                </gmap-custom-marker> -->

                            </template>
                            <template v-else>
                                <gmap-marker
                                        :position="createGoogleMarker('',firstRecord(tickets).entity).position"
                                        :clickable="false"
                                        :icon="mapIcon()"
                                />
                            </template>
                            <!--// set the venue marker-->
                            <gmap-marker
                                    :position="createGoogleMarker('venue').position"
                                    :clickable="false"
                                    :icon="mapIcon('venue')"
                            />
                            <!--<map-marker-overlay></map-marker-overlay>-->
                        </google-map>
                    </div>

                    <!------------------ tickets list ------------------------->
                    <template v-for="(ticket,index) in tickets">
                        <article data-ref="list-each-ticket" class="px-3"
                                 :data-ref-len="tickets.length"
                            :class="{
                            'sold_out_ticket_list_item pb-1 ':soldOut(ticket),
                            'pb-3':!soldOut(ticket)
                            }"
                        >
                            <!--ticket badges-->
                            <template data-ref="badges" v-if="!soldOut(ticket)">
                                <div v-if="createTicketAttributeClass(ticket).length > 0" class="mb-2">
                                <span v-if="createTicketAttributeClass(ticket).indexOf('product-on_sale') >= 0"
                                      class="badge badge-primary product-on_sale"
                                >On Sale</span>

                                    <span v-if="createTicketAttributeClass(ticket).indexOf('product-recommended') >= 0"
                                          class="badge badge-primary product-recommended"
                                    >Recommended</span>

                                    <span v-if="createTicketAttributeClass(ticket).indexOf('product-premium') >= 0"
                                          class="badge badge-primary product-premium"
                                    >Premium</span>
                                    <span v-if="createTicketAttributeClass(ticket).indexOf('product-blue-badge') >= 0"
                                          class="badge badge-primary product-blue-badge"
                                    >Blue Badge</span>
                                </div>
                                <div v-else class="mb-2">
                                    <span class="badge badge-primary product-standard">Standard</span>
                                </div>
                            </template>

                            <!--ticket name details and buttons-->
                            <div :key="ticket.id" :id="`ticket-selection--${ticket.id}`"
                                 :data-ticket_id="ticket.id"
                                 data-ref="ticket-details"
                                 class="row container"
                                 :class="{
                                     'mt-2':tickets.length <= 1
                                 }"
                            >
                                <div data-ref="ticket_details_list" :class="{
                                    'col-12 col-sm-6 col-md-12 col-xl-7':canBuyNow(),
                                    'col-12 col-lg-7':!canBuyNow()
                                }">
                                    <!--ticket details list-->
                                    <ticket-details-list
                                            data-ref="ticket-details-list"
                                            :ticket="ticket"
                                            :sold_out_tickets="sold_out_tickets"
                                            :sold_out="soldOut(ticket)"
                                            :show_icon="true"
                                            :show_time="true"
                                            @show_ticket_description="ticketDescriptionSelected"
                                            @entity_selected="entitySelected"
                                    />
                                    <!--eof ticket details list-->
                                </div>
                                <!--the buttons display-->
                                <div data-ref="data_buttons_display"
                                     class=" "
                                     :class="[
                                         ticket_buttons_class,
                                         {
                                             'mt-1 mt-md-1 mt-xl-0':!soldOut(ticket),
                                             'm-0':soldOut(ticket),
                                         }

                                     ]"
                                >
                                    <div data-ref="data-button-flex"
                                         class="p-0 row container no-gutters justify-content-end d-flex"
                                    >
                                        <div v-if="canBuyNow() && !eventExpired() && !soldOut(ticket)"
                                             class="ml-2 mb-2">
                                            <vue-btn
                                                    @buttonClick="buyNow(ticket)"
                                                    icon="credit_card"
                                                    class="btn-primary m-0"
                                                    data-ref="buy-now-button"
                                            >
                                                <template slot="content">
                                                    1-click
                                                </template>
                                            </vue-btn>
                                        </div>
                                        <span v-else-if="!eventExpired() && !soldOut(ticket)"
                                              v-on:click="addToBasket(ticket)"
                                              class="align-self-center ml-2 mb-2">
                                        <span v-if="is_mobile">
                                            Touch
                                        </span>
                                        <span v-else>
                                            Click
                                        </span>
                                         <span>to buy</span>
                                    </span>
                                        <buy-button
                                                class="ml-2 "
                                                :class="{
                                            'mb-2':!soldOut(ticket)
                                                }"
                                                cls="m-0 position-relative"
                                                :cls="{
                                            'btn-small':soldOut(ticket)
                                                }"
                                                @buttonClick="addToBasket(ticket)"
                                                :ticket="ticket"
                                                :can_buy_now="canBuyNow()"
                                                :event_expired="eventExpired()"
                                                :limited="hasLimited(ticket)"
                                                :sold_out="soldOut(ticket)"
                                                :ticket_price="ticket.price"
                                                :ticket_id="ticket.id"
                                        >
                                        </buy-button>

                                    </div>
                                </div>
                            </div>
                            <!--ticket description-->
                            <transition name="fade">
                                <div class="bg-level-1"
                                     data-ref="ticket-description"

                                >
                                    <div
                                            v-if="showTicketDescription(ticket.id)"
                                            v-html="ticket_descriptions[ticket.id].html"
                                    ></div>
                                </div>
                            </transition>
                            <div style="text-align:center;" class="mb-2" v-if="ticket.entity.lez_applicable === 1">
                                <br />
                                <span class="badge badge-success"><a style="background:inherit; color:inherit;" href="https://tfl.gov.uk/modes/driving/check-your-vehicle/" target="_blank">{{ticket.entity.lez_text}}</a></span>
                            </div>


                        </article>
                        <hr class="mt-0" v-if="tickets.length > 1 && index !== tickets.length - 1">
                    </template>
                </div>
            </template>
        </div>
        <!--start the loop immediately-->
        <!--list tickets loop-->
    </div>
</template>

<script>
    import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang';
    import {percentage} from '../../../../../app/Shared/Resources/Assets/js/helpers/calc';
    import {format as formatMoney} from '../../../../../app/Shared/Resources/Assets/js/helpers/money';
    import {length} from '../../../../../app/Shared/Resources/Assets/js/helpers/object.formats';
    import {ticket_types} from '../../../../../app/Shared/Resources/Assets/js/helpers/ticketIcons';
    import isPast from 'date-fns/is_past';
    import {_ as us} from 'underscore';
    import {GOOGLEMAPS_API_KEY} from '../../config/config';
    import * as VueGoogleMaps from 'vue2-google-maps';
    import GmapCustomMarker from '../maps/gmap-custom-marker';
    import {stringToProperty} from '../../../../../app/Shared/Resources/Assets/js/helpers/object.formats'
    import GeminiScrollbar from 'vue-gemini-scrollbar';
    import BasketToastr from '../basket/BasketToastr.js';
    import BasketAddAnimation from '../basket/BasketAddAnimation.js';

    Vue.use(GeminiScrollbar);
    Vue.component('buy-button', require('../../../../../app/Shared/Resources/Assets/js/components/buttons/BuyButton'));
    Vue.component('vue-btn', require('../../../../../app/Shared/Resources/Assets/js/components/buttons/Buttons.vue'));
    Vue.component('header-overlay', require('../../../../../app/Shared/Resources/Assets/js/components/headers/HeaderOverlay'));
    Vue.component('round-button', require('../../../../../app/Shared/Resources/Assets/js/components/buttons/RoundButton'));
    Vue.component('street-sign', require('../../../../../app/Shared/Resources/Assets/js/components/StreetSign'));
    Vue.component('confirm-buy-now', require('../modals/ConfirmBuyNow.vue'));
    Vue.component('ticket-details-list', require('./TicketDetailsList'));
    // Vue.component('ticket-list-item', require('./TicketListItem'));

    Vue.use(VueGoogleMaps, {
        load: {
            key: GOOGLEMAPS_API_KEY,
            // v: '3.26',
            // v: 'OPTIONAL VERSION NUMBER',
            // libraries: 'places', //// If you need to use place input
        }
    });
    Vue.component('google-map', VueGoogleMaps.Map);
    export default {
        name: "ticket-list",
        mixins: [BasketToastr, BasketAddAnimation],
        components: {
            'gmap-custom-marker': GmapCustomMarker
        },
        props: {
            user: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            payment_intent_request: {
                type: String,
                default: null
            },
            map_lat: {
                type: Number,
                default: null
            },
            map_lng: {
                type: Number,
                default: null
            },
            ticket_wrapper_id: String,
            add_ticket_url: Object,
            entity_id_prefix: String,
            entity: Function | Object,
            entity_highlight_target: Function | String | Number,
            images: Object,
            images_url: Object,
            my_account_url: Object,
            pay_with_card_url: Object,
            show_map: Boolean,
            show_remaining: Boolean,
            start_date: Function | String,
            ticket_classes: Object,
            tickets: Function | Array,
            stripe_use: {
                type: Object,
                default: null
            },
        },
        created() {

        },
        destroyed() {
        }
        ,
        mounted() {
            let self = this;

            this.is_mobile = this.isMobileDevice();
            this.$nextTick(function () {

            });
        }
        ,
        data() {
            return {
                is_mobile: false,
                ticket_buttons_class: 'col-12 col-sm-6 col-md-12 col-xl-5',
                debugging: false,
                entity_sign_class: '',
                manual_override_show_mini_map: true,
                ticket_descriptions: {},
                tickets_grouped_by_entity: {},
                tickets_clicked: [],
                ticket_toasters: {},
                toastr_last: {},
                toastr_options: {
                    newestOnTop: true,
                    progressBar: true,
                    timeOut: 6000,
                    positionClass: "toast-top-right",
                    showMethod: 'slideDown',
                    hideMethod: 'slideUp',
                    showDuration: "200",
                },
                ordered_tickets: {},
                grouped_by_entity:[],
                sold_out_tickets: {},
                display_entities: {},
                show_entity: false,
                selected_ticket: null,
                entities: Object,
                display_entity_list: Object,
                displayChanged: false,
                entityGroup: {},
                map_loaded: false,
                google_maps: {
                    options: {
                        zoomControl: false,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: false,
                        disableDefaultUi: false,
                        draggable: false,
                        scrollwheel: false,
                    },
                    center: {
                        lat: this.map_lat,
                        lng: this.map_lng
                    },
                    infoContent: {
                        title: '',
                        description: {
                            long: '',
                            short: ''
                        }
                    },
                    infoWindowPos: {
                        lat: 0,
                        lng: 0
                    },
                    infoWinOpen: false,
                    currentMidx: null,
                    //optional: offset infowindow so it visually sits nicely on top of our marker
                    infoOptions: {
                        pixelOffset: {
                            width: 0,
                            height: -35
                        }
                    },
                    markers: []
                },
                testObj: Object
            }
        }
        ,
        methods: {
            showTicketDescription(ticket_id){
                return (this.ticket_descriptions.hasOwnProperty(ticket_id) && this.ticket_descriptions[ticket_id].active === true);
            },
            readEntityType(entity) {
                return entity.entity_data.entity_type.slug;
            }
            ,
            uniqueId(item) {
                return _.uniqueId(item);
            }
            ,
            entityUniqueId(data) {
                return `${this.entity_id_prefix}${data.id}`;
            }
            ,
            isMobileDevice() {
                return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
            }
            ,
            entitySelected(data) {
                console.log('data', data);
            }
            ,
            createTicketMarketingAttributes(ticket) {
                let attributes = stringToProperty('ticket_data.attributes', ticket),
                    classes = [];

                if (attributes.length > 0) {
                    for (let i = 0; i < attributes.length; i++) {
                        let attribute = attributes[i].slug;
                        switch (attribute) {
                            case 'on_sale':
                                classes.push('product-on_sale');
                                break;

                            case 'recommended':
                                classes.push('product-recommended');
                                break;

                            case 'premium':
                                classes.push('product-premium');
                                break;
                        }
                        // console.log('createTicketAttributeClass', 'attribute', attribute);
                    }
                }
                return classes.join(' ');
            }
            ,
            createTicketAttributeClass(ticket) {
                let attributes = stringToProperty('ticket_data.attributes', ticket),
                    classes = [];
                if (attributes.length > 0) {
                    for (let i = 0; i < attributes.length; i++) {
                        let attribute = attributes[i].slug;
                        // console.log('attribute',attribute)
                        switch (attribute) {
                            case 'on_sale':
                                classes.push('product-on_sale');
                                break;

                            case 'recommended':
                                classes.push('product-recommended');
                                break;

                            case 'premium':
                                classes.push('product-premium');
                                break;
                            case 'blue-badge':
                                classes.push('product-blue-badge');
                                break;
                        }
                        // console.log('createTicketAttributeClass', 'attribute', attribute);
                    }
                }
                // console.log('createTicketAttributeClass', 'classes', classes);
                return classes.join(' ');
            }
            ,
            ticketDescriptionSelected(ticket) {
                let self = this;

                self.$set(self.ticket_descriptions, ticket.id, {
                    active: ticket.set_active,
                    html: ticket.description
                });
            }
            ,
            soldOut(ticket) {
                return (ticket.remaining <= 0);
            }
            ,
            hasLimited(ticket) {
                let self = this,
                    percentageValue = percentage(ticket.remaining, ticket.allocated);
                // self.log('ticket',ticket);
                // self.log('percentageValue',percentageValue);

                if (percentageValue <= 10) {
                    return true;
                }

                return false;
            }
            ,
            setEntity(entity_id) {
                this.display_entities[entity_id] = {
                    display: false,
                    entity_id: entity_id
                };

                return this.display_entities;

            }
            ,
            toggleShowEntityEvent(entityId) {
                // console.log('toggleShowEntityEvent', 'this.displayChanged', this.displayChanged);
                this.display_entities[entityId].display = false;
                this.displayChanged = !this.displayChanged;
            }
            ,
            eventExpired() {
                return isPast(new Date(this.start_date));
            }
            ,
            canBuyNow() {
                if (typeof this.pay_with_card_url !== 'undefined' && this.pay_with_card_url != null) {
                    if (this.pay_with_card_url.params.value != null && this.pay_with_card_url.params.value != '') {
                        return true;
                    }
                } else {
                    return false;
                }
            }
            ,
            log(...args) {
                console.log(...args);
            }
            ,
            eventConfirmBuyNow(data) {
                switch (data.action) {
                    case 'cancel':
                        this.selected_ticket = null;
                        break;
                }
            }
            ,
            addToBasket(ticket) {
                // console.log('addToBasket', 'ticket',ticket);
                let self = this,
                    index = _.indexOf(self.tickets_clicked, ticket.id);

                // check if the ticket has already been clicked before releasing

                // the item has already been requested and not yet returned a confirmation
                if (index >= 0) {
                    self.showToastr('warning', {message: 'please wait while we get your ticket'});
                    return false;
                } else {

                    // console.log('addToBasket', 'ticket', ticket);
                    // console.log('addToBasket', 'self.soldOut(ticket)',self.soldOut(ticket));
                    if (self.soldOut(ticket) === true) {
                        self.showToastr('warning', {message: 'Ticket sold out'});
                        self.tickets_clicked = self.removeTicketFromWaitingList(ticket.id);
                        // console.log('addToBasket', 'self.soldOut(ticket)', 'here');
                        return false;
                    } else {
                        // console.log('addToBasket', 'showToastr');
                        self.showToastr('info', {message: 'checking for available tickets'});
                        // console.log('addToBasket', 'addTicketToBasket');

                        self.addTicketToBasket(ticket, function (response) {
                            // console.log('response',response)
                            if (response.data.sold_out === true) {
                                self.clearToastr(self.toastr_last);
                                // toastr.clear(self.toastr_last);
                                self.tickets_clicked = self.removeTicketFromWaitingList(ticket.id);
                                self.showToastr('warning', {message: 'this ticket is sold out'});
                            } else if (response.data.exceeded === true) {
                                let maxNumberOfTickets = response.data.limit;

                                self.clearToastr(self.toastr_last);
                                self.tickets_clicked = self.removeTicketFromWaitingList(ticket.id);
                                self.showToastr('warning', {message: 'Only ' + maxNumberOfTickets + ' per purchase'});
                            } else {
                                self.setAnimationComponent(
                                    'ticket-selection--',
                                    ticket,
                                    function () {
                                        // remove reserve from ticket adding process
                                        self.tickets_clicked
                                            = self.removeTicketFromWaitingList(ticket.id);
                                        self.$basketController.$emit('read_basket', ticket.id);

                                    });
                            }
                        });
                    }
                }
            }
            ,
            removeTicketFromWaitingList(ticket_id) {
                let self = this,
                    index = _.indexOf(self.tickets_clicked, ticket_id);

                if (index > -1) {
                    self.$delete(self.tickets_clicked, index);
                }

                return self.tickets_clicked;
            }
            ,
            addTicketToBasket(ticket, callback) {
                let data = {};
                this.tickets_clicked.push(ticket.id);

                axios.post(`${this.add_ticket_url.data}/${ticket.id}`, data)
                    .then(function (response) {
                        // console.log('response.data',response.data);
                        callback(response);
                    })
                    .catch(function (e) {
                    });
            }
            // ,
            // showToastr(type, params) {
            // 	let self = this,
            // 		title = ('title' in params) ? `<div>${params.title}</div>` : '',
            // 		message = `<div class="p-3">${params.message}</div>`
            // 	;
            // 	if (self.debugging) {
            // 		self.toastr_options.progressBar = false;
            // 		self.toastr_options.timeOut = false;
            // 	}
            //
            // 	toastr.options = self.toastr_options;
            //
            // 	self.toastr_last = toastr[type](
            // 		`${title}
            //         ${message}`
            // 	);
            // }
            // ,
            // offset(el) {
            // 	let rect = el.getBoundingClientRect(),
            // 		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            // 		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            // 	return {top: rect.top + scrollTop, left: rect.left + scrollLeft}
            // }
            ,
            buyNow(ticket) {
                this.selected_ticket = ticket;
            }
            ,
            triggerEntityView() {
                this.$emit('event_handler', {});
            }
            ,
            preloadImage(tickets) {
                let url = this.createMainImage(_.first(tickets).entity);
                if (url === null) {
                    return null;
                }
                if (url in this.images) {
                    return this.images[url];
                } else {
                    console.warn('no image for entity');
                    let my_image = new Image();

                    my_image.onload = function () {
                        // console.log('image loaded');
                    };

                    my_image.src = url;
                    this.$set(this.images, url, my_image);
                    // this.images.put(url,my_image);
                    return my_image;
                }

            }
            ,
            createMainImage(entity) {
                let url = this.readImageFromData(entity);
                if (url === null) {
                    console.error('images is null', entity);
                    return null;
                }
                url = this.images_url.data + '/' + url.url;
                return url;
            }
            ,
            readImageFromData(entity) {
                let url = _.first(entity.images) || null;
                if (url === null) {
                    return null;
                }
                return url;
            }
            ,
            groupByEntity() {

                let self = this,
                    groupedEntities = {},
                    groups = {},
                    orderedTicketLength = length(this.ordered_tickets),
                soldOutTickets = {};

                if (orderedTicketLength <= 0) {
                    return null;
                }

                for (let x = 0; x < orderedTicketLength; x++) {
                    /**
                     * @property orderedTicket.remaining
                     * @namespace orderedTicket
                     */
                    let orderedTicket = this.ordered_tickets[x],
                        entity = orderedTicket.entity_id;

                    // is there an entity record there already?
                    if (!groupedEntities.hasOwnProperty(entity)) {
                        groupedEntities[entity] = [];
                    }

                    // add to soldOut array for later display
                    if(this.soldOut(orderedTicket)){
                        if(!soldOutTickets.hasOwnProperty(entity)){
                            soldOutTickets[entity] = [];
                        }
                        soldOutTickets[entity].push(orderedTicket);
                    }else{
                        // add the record to the entity
                        groupedEntities[entity].push(orderedTicket);
                    }
                }
                for (let soldOutTicketsEntityKey in soldOutTickets){
                    let len = soldOutTickets[soldOutTicketsEntityKey].length;
                    for(let s = 0; s < len; s++){
                        groupedEntities[soldOutTicketsEntityKey].push(soldOutTickets[soldOutTicketsEntityKey][s])
                    }
                }

                for (let groupedEntitiesKey in groupedEntities) {
                    let group = groupedEntities[groupedEntitiesKey];
                    // console.log('groupByEntity', 'group',group);
                    let ticket_weights = [];
                    let entity_slug = '';

                    for (let ticket_index = 0; ticket_index < group.length; ticket_index++) {
                        /**
                         *
                         * @property groupElement.lft
                         * @namespace groupElement
                         */
                        let groupElement = group[ticket_index];
                        entity_slug = group[ticket_index].entity.id;
                        // entity_slug = group[ticket_index].entity.slug;
                        // console.log('groupElement', groupElement);
                        ticket_weights.push(groupElement.lft);

                    }
                    let group_weight = _.min(ticket_weights);

                    groups[entity_slug] = {
                        entity_id: parseInt(groupedEntitiesKey),
                        entity_key: entity_slug,
                        tickets: group,
                        lft: group_weight
                    };

                    // console.log('groupedEntitiesKey', groupedEntitiesKey, 'group_weight', group_weight);
                }

                let compiled = {};

                for (let selfKey in groups) {
                    let group = groups[selfKey];

                    if (!compiled.hasOwnProperty(group.entity_key)) {
                        compiled[group.entity_key] = [];
                    }
                    compiled[group.entity_key] = group.tickets;
                }
                return compiled;
            }
            ,
            firstRecord(data) {
                return _.first(data);
            }
            ,
            /**
             * User clicks to show the entity
             * @param entity
             */
            viewEntity(entity) {
                let workAround = {},
                    group = this.grouped_by_entity;
                // console.log('viewEntity', 'group', group);

                for (let key in group) {
                    // console.log('viewEntity', 'key', key, 'group', group, 'entity', entity);
                    let displayKey = _.first(group[key]).entity_id;
                    workAround[displayKey] = {
                        display: (parseInt(displayKey) == entity.id) ? true : false,
                        entity_id: displayKey
                    }
                }

                // console.log('workAround', workAround, typeof workAround);

                this.display_entities = workAround;
                this.displayChanged = !this.displayChanged;
                // console.log('viewEntity', 'this.displayChanged',this.displayChanged);
                // console.log('entity', entity);
                this.$emit('entity_selected', entity)

            }
            ,
            formatMoney(price) {
                return formatMoney(price, {
                    code: $('body').data('currency')
                });
            }
            ,
            lang(path, object) {
                // console.log('object',object);
                return lang(path, object)
            }
            ,
            ticketTypeIconClass(ticket) {
                return ticket_types(ticket.ticket_type, false);
            }
            ,
            /**
             * returns entity from ticket or tickets prop
             * @param tickets
             * @returns {*}
             */
            readEntity(tickets) {
                if (typeof tickets !== 'undefined' && tickets !== null) {
                    return this.firstRecord(tickets).entity;
                }
                return this.firstRecord(this.tickets).entity;
            }
            ,
            createGoogleMarker(marker_type, entity) {
                let self = this, tickets = this.ordered_tickets;

                /**
                 * send back the venue details
                 * @return {Object}
                 * */
                if (marker_type === 'venue') {

                    return {
                        position: {
                            lat: this.google_maps.center.lat,
                            lng: this.google_maps.center.lng
                        },
                        icon: 'car'
                    };
                }

                if (_.isEmpty(tickets)) {
                    return false;
                }

                if (typeof entity !== 'undefined' && entity !== null) {
                    /**
                     * @property entityData.entity_type.entity_type_data.input_fields.groups
                     * @property entityData.entity_type.entity_type_data.input_fields
                     * @property entityData.entity_type.entity_type_data
                     * @property entityData.entity_type.slug
                     * @property entityData.entity_type
                     * @namespace
                     */
                    let entityData = entity.entity_data;
                    let gmapsData = entityData.entity_type.entity_type_data.input_fields.groups.location.items
// console.log('entityData.entity_type.slug',entityData.entity_type.slug);
                    if (entityData.entity_type.slug.indexOf('car', 'car-park') > -1) {
                        return {
                            position: {
                                lat: parseFloat(JSON.parse(gmapsData.geocode.value).geometry.location.lat),
                                lng: parseFloat(JSON.parse(gmapsData.geocode.value).geometry.location.lng)
                            },
                            infoContent: {
                                title: lang('title', entityData.lang),
                                description: {
                                    short: lang('description.short', entityData.lang),
                                    long: lang('description.long', entityData.lang)
                                },
                                sign: entityData.sign
                            },
                            icon: 'car'
                        };
                    }

                }
                return null;

            }
            ,
            createGoogleMapsCenter() {
                //has markers
                //this.ordered_tickets
// console.log('createGoogleMapsCenter', 'this.ordered_tickets',this.ordered_tickets);
                let markers = this.createGoogleMarker();
                console.log('createGoogleMapsCenter', 'markers', markers);
                if (!markers) {
                    return false;
                }
                //
                let position = markers.position;

// console.log('position',position,'this.google_maps.center',this.google_maps.center,'result',result);
                return {
                    lat: (position.lat + this.google_maps.center.lat) / 2,
                    lng: (position.lng + this.google_maps.center.lng) / 2,
                };
            }
            ,
            mapIcon(type) {
                if (type === 'venue') {
                    // console.log('process.env.MIX_VENUE_MARKER',process.env.MIX_VENUE_MARKER);

                    return process.env.MIX_VENUE_MARKER;

                }
                // let self = this,
                // 	entity = self.readEntity(),
                // 	info = self.createGoogleMapsInfoWindowData(entity);
                //
                // console.log('info', info);
                // let icon = info.icon,
                //
                // 	list = [
                // 		'yellow-dot.png', 'red-dot.png', 'blue-dot.png'
                // 	];
                //
                // let mapMarkerLocation = process.env.MIX_MAPS_MARKER_CAR;
                return process.env.MIX_MAPS_MARKER_CAR;
                // return `<div>I am a marker</div>`;

            }
            ,
            createGoogleMapsInfoWindowData(entity) {
                // console.log('entity', entity);
                let
                    compiledInfoData = [],
                    entityData = entity.entity_data;

                // console.log('entityData', entityData);

                let
                    gmapsData = entityData.entity_type.entity_type_data.input_fields.groups.location.items,
                    lat = JSON.parse(gmapsData.geocode.value).geometry.location.lat,
                    long = JSON.parse(gmapsData.geocode.value).geometry.location.lng,
                    title = lang('title', entityData.lang),
                    description = {
                        short: lang('description.short', entityData.lang),
                        long: lang('description.long', entityData.lang)
                    };
                compiledInfoData = {
                    position: {
                        lat: parseFloat(lat),
                        lng: parseFloat(long)
                    },
                    infoContent: {
                        title: title,
                        description: description
                    },
                    icon: 'car'
                };
                this.google_maps.markers = compiledInfoData;
                this.map_loaded = true;
                return compiledInfoData;
            }
        }
        ,
        watch: {
            tickets(items) {
                let self = this;

                // console.log('items',items, 'this.items',items[0]);
                // let ordered = _.sortBy(items,'lft');
                // console.log('tickets', 'updating', items);
                this.ordered_tickets = items;
                this.grouped_by_entity = this.groupByEntity();
                // this.initEntityGroups();

                // console.log('ordered', ordered);
                // console.log('this.ordered_tickets', this.ordered_tickets);
                // for (var orderedTicketsKey in this.ordered_tickets) {
                //    // console.log('orderedTicketsKey',orderedTicketsKey);
                //    let item = this.ordered_tickets[orderedTicketsKey];
                //    // console.log('orderedTicketsKey',item.ticket_data.lang.en_GB.title);
                // }
            }
        }
        ,
        computed: {
            ticketsByEntity() {

            }
        }
    }
</script>

<style scoped>
    .tickets-container {
        /*margin-top: 3em;*/
        margin-bottom: 1em;
        position: relative;
    }

    .tickets-list--scroll {
        height: 75vh;
    }

    .sold_out_ticket_list_item{
        color:grey !important;
    }
    /* override gemini-scrollbar default styles */

    /* vertical scrollbar track */
    .gm-scrollbar.-vertical {
        background-color: #f0f0f0
    }

    /* horizontal scrollbar track */
    .gm-scrollbar.-horizontal {
        background-color: transparent;
    }

    /* scrollbar thumb */
    .gm-scrollbar .thumb {
        background-color: rebeccapurple;
    }

    .gm-scrollbar .thumb:hover {
        background-color: fuchsia;
    }

    .gm-scrollbar-container .gm-scroll-view {
    transform: initial;
    }    
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/tickets/TicketList.vue